<template>
  <button
    :data-testid="`carousel-${arrowType}-button`"
    :class="desktopArrowClass.container"
    :aria-label="ariaLabel"
    @click.stop="arrowClick(arrowType)"
  >
    <span :class="desktopArrowClass.arrow" />
  </button>
</template>
<script lang="ts">

import type { SimpleCarouselArrow } from '~~/types/components/SimpleCarousel/SimpleCarouselArrows';
import { SIMPLE_CAROUSEL_ARROW } from '~~/types/components/SimpleCarousel/SimpleCarouselArrows';
export default defineComponent({
  name: 'SimpleCarouselButton',
  props: {
    arrowType: {
      type: String as PropType<SimpleCarouselArrow>,
      required: true,
    },
  },
  emits: ['arrowClicked'],
  setup(props, { emit }) {

    const i18n = useI18n();

    const desktopArrowClass = {
      container: 'w-9 h-9 rounded border-2 border-EXPONDO-grey-20 flex items-center justify-center ' +
          'bg-EXPONDO-white text-EXPONDO-primary-80 text-xl font-light cursor-pointer',
      arrow: `iconify svg--chevron-${props.arrowType === SIMPLE_CAROUSEL_ARROW.prev ? 'left' : 'right'}`,
    };

    const ariaLabel = computed(() => {

      return props.arrowType === SIMPLE_CAROUSEL_ARROW.prev ? i18n.t('Scroll left') : i18n.t('Scroll right');
    
    });

    const arrowClick = (arrowType:SimpleCarouselArrow) => {

      emit('arrowClicked', arrowType);
    
    };

    return {
      desktopArrowClass,
      arrowClick,
      ariaLabel,
    };
  
  },
});

</script>
